module.exports = __webpack_public_path__ + "static/img/img_yewu1.13bf3d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_yewu1.png
// module id = ibl5
// module chunks = 1